/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, Input, Renderer2} from '@angular/core';

declare var Prism: any;
export class CodeHighlight {
private _highlight: string = "";
/**
 * @param {?} _el
 * @param {?} renderer
 */
constructor(private _el: ElementRef,
private renderer: Renderer2) {}
/**
 * @return {?}
 */
ngAfterContentInit(): void {
        this.redraw();
    }
/**
 * @return {?}
 */
public redraw() {
        if (this._el && this._el.nativeElement) {
            Prism.highlightElement(this._el.nativeElement);
        }
    }
/**
 * @param {?} val
 * @return {?}
 */
set highlight(val: string) {
        if (val && val.trim() !== "") {
            this._highlight = val;
            this.renderer.addClass(this._el.nativeElement, this._highlight);
        }
    }
/**
 * @return {?}
 */
get highlight(): string {
        return this._highlight;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "code[clr-code-highlight]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'highlight': [{ type: Input, args: ["clr-code-highlight", ] },],
};
}

function CodeHighlight_tsickle_Closure_declarations() {
/** @type {?} */
CodeHighlight.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CodeHighlight.ctorParameters;
/** @type {?} */
CodeHighlight.propDecorators;
/** @type {?} */
CodeHighlight.prototype._highlight;
/** @type {?} */
CodeHighlight.prototype._el;
/** @type {?} */
CodeHighlight.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
